<template>
  <v-menu
    v-model="isCompetitorSelectionOpen"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small v-bind="attrs" v-on="on">
        <v-icon v-once>filter_list</v-icon>
      </v-btn>
    </template>
    <v-card class="pa-2">
      <v-autocomplete
        v-model="newSelectedCompetitors"
        dense
        multiple
        return-object
        hide-details
        :items="nonStoreGroupCompetitors"
        :item-disabled="isCompetitorDisabled"
        item-text="competitorDisplayDescription"
        item-value="_id"
        @blur="onCompetitorsChange"
      />
    </v-card>
  </v-menu>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { maxCompetitorsDisplayCount } from '@enums/feature-flags';

export default Vue.extend({
  data() {
    return {
      newSelectedCompetitors: [],
      isCompetitorSelectionOpen: false,
    };
  },

  computed: {
    ...mapState('gridView', ['selectedCompetitors']),
    ...mapState('clientConfig', ['toggleLogic']),
    ...mapGetters('competitorMetadata', ['nonStoreGroupCompetitors']),
  },

  created() {
    this.newSelectedCompetitors = [...this.selectedCompetitors];
  },

  methods: {
    ...mapActions('gridView', ['setSelectedCompetitors']),

    isCompetitorDisabled(competitor) {
      // don't allow to select more than maxCompetitorsDisplayCount
      if (this.newSelectedCompetitors.length === this.toggleLogic[maxCompetitorsDisplayCount]) {
        return !this.newSelectedCompetitors.some(c => c._id === competitor._id);
      }

      // don't allow to deselect all competitors
      if (this.newSelectedCompetitors.length === 1) {
        return this.newSelectedCompetitors.some(c => c._id === competitor._id);
      }

      return false;
    },

    onCompetitorsChange() {
      this.setSelectedCompetitors(this.newSelectedCompetitors);
      this.globalEmit('competitor-selection-changed');
    },
  },
});
</script>
